import { Link } from 'react-router-dom'
import { ArrowUpRightIcon } from '@heroicons/react/24/outline'
import { H2, Paragraph, SmallText } from '../../components/typography/Typography'
import { ANALYTICS_EVENTS, track } from '../../lib/analytics'
import hallSystemDiagram from '../../assets/hall-system-diagram.webp'

// The two adjacent ranges being added alongside seating. Routes are declared
// here so the pills can be pointed elsewhere in one edit while those sections
// of the site are still being built.
const CROSS_SELL = [
    { label: 'Sports Flooring', href: '/sports-flooring' },
    { label: 'Facility Equipment', href: '/facility-equipment' },
]

export const RestOfTheHall = () => {
    return (
        <section className='flex flex-col gap-8 px-4 md:px-24 lg:flex-row lg:items-center lg:gap-16'>
            <div className='flex flex-col gap-3 md:gap-4 lg:w-[42%] lg:shrink-0'>
                <SmallText className='tracking-[0.25em] text-gray-500'>Also from XtractPro</SmallText>
                <H2>The rest of the hall</H2>
                <Paragraph className='text-gray-600'>
                    Floor and equipment from the same supplier as the seating. Anchor positions,
                    backstop centre lines, sleeve locations and line markings are set once, on one
                    drawing, before the floor goes down.
                </Paragraph>

                <div className='mt-1 grid grid-cols-2 gap-3 sm:mt-2 sm:flex sm:flex-wrap'>
                    {CROSS_SELL.map(({ label, href }) => (
                        <Link
                            key={href}
                            to={href}
                            onClick={() =>
                                track(ANALYTICS_EVENTS.HOME_CROSS_SELL_CLICKED, {
                                    range: label,
                                    destination: href,
                                })
                            }
                            className='group inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 px-4 py-2.5 text-center font-inter text-sm text-gray-900 transition-colors hover:border-gray-900 sm:gap-2 sm:px-5 sm:text-base md:px-6 md:py-3'
                        >
                            {label}
                            <ArrowUpRightIcon className='size-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5' />
                        </Link>
                    ))}
                </div>
            </div>

            {/* The render is a wide letterbox; the rounded gray panel keeps its own
                pale background from reading as a hard-edged rectangle. */}
            <div className='overflow-hidden rounded-2xl bg-gray-100 lg:flex-1'>
                <img
                    src={hallSystemDiagram}
                    alt='Sports hall cutaway showing wall padding, an electric stage, hardwood sports flooring, ceiling-mount basketball backstops, divider curtains and telescopic seating'
                    width={1440}
                    height={654}
                    loading='lazy'
                    decoding='async'
                    className='h-auto w-full'
                />
            </div>
        </section>
    )
}
